import { ArrowRight, CheckCircle, MapPin, Package, ShieldCheck, Truck } from "@phosphor-icons/react";

const LAUNCH_IMAGE = "/assets/loado-launch.png";

export const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const highlights = [
    "Construction logistics",
    "Material sourcing",
    "Verified local network"
  ];

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen pt-20 lg:pt-24 overflow-hidden bg-[#020617]"
    >
      <div className="absolute inset-0">
        <img
          src={LAUNCH_IMAGE}
          alt="Loado construction logistics launch"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#020617]/95 via-[#020617]/70 to-[#020617]/20"></div>
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#020617] to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 min-h-[calc(100vh-5rem)] flex items-center">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 border border-white/15 rounded-lg mb-8">
            <MapPin size={18} weight="duotone" className="text-[#FF5500]" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-white">
              Launching in Chennai
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black text-white leading-tight mb-6">
            Construction supply,
            <br />
            moved the Loado way.
          </h1>

          <p className="text-lg lg:text-xl text-slate-200 leading-relaxed max-w-2xl mb-8">
            Loado brings construction material sourcing and vehicle booking into one
            practical platform for site teams, builders, suppliers, and delivery partners.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-book-vehicle-btn"
              onClick={() => scrollToSection("#logistics")}
              className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#0055FF] text-white font-semibold text-lg rounded-lg btn-lift"
            >
              <Truck size={24} weight="bold" />
              Explore Logistics
              <ArrowRight size={20} weight="bold" className="transition-transform group-hover:translate-x-1" />
            </button>
            <button
              data-testid="hero-shop-materials-btn"
              onClick={() => scrollToSection("#materials")}
              className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#FF5500] text-white font-semibold text-lg rounded-lg btn-lift"
            >
              <Package size={24} weight="bold" />
              Source Materials
              <ArrowRight size={20} weight="bold" className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          <div className="flex flex-wrap gap-3 pt-8">
            {highlights.map((item, index) => (
              <div key={item} className="flex items-center gap-2 px-4 py-2 bg-white/10 border border-white/15 rounded-lg">
                {index === 0 ? (
                  <Truck size={18} weight="duotone" className="text-[#0055FF]" />
                ) : index === 1 ? (
                  <Package size={18} weight="duotone" className="text-[#FF5500]" />
                ) : (
                  <ShieldCheck size={18} weight="duotone" className="text-green-400" />
                )}
                <span className="text-sm font-medium text-slate-100">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden lg:flex items-center gap-2 text-white/70">
        <CheckCircle size={18} weight="fill" className="text-[#0055FF]" />
        <span className="text-sm font-medium">Materials, vehicles, tracking, and partner support</span>
      </div>
    </section>
  );
};
